// @flow

import debounce from 'lodash/debounce'
import { getPolopolyImageElement, getImageElement } from '../utils/imageUtils'
import { constrain } from '../utils/general'

import videoStyles from '../stylesheets/video.css'
import { background, uncroppedImageContainer } from '../stylesheets/background.css'
import { alignCenter, alignMiddle } from '../stylesheets/alignment/index.css'

let eventListener = null

type videoType = {
  mp4: string,
  webm: string,
  poster: string,
  subtitles: ?Object
}

type videoHandlerTypeProps = {
  video: videoType,
  alignment: ?Array<string>
}

export const animateVideoComponent = {
  type: 'animate-video',

  render(id: string, props: videoHandlerTypeProps, bgInnerHTML: ?string = '') {
    const { video, alignment } = props
    const { mp4, webm, poster, subtitles, hasSound } = video

    const trackElement = subtitles ?
      `<track src="${
          subtitles
        }" kind="caption" srclang="no" label="Norwegian" default="" />` :
      ''

    const alignmentClasses = alignment.join(' ')

    return `
      <div id="${id}" class="${background} ${videoStyles.hidePlay}" >
        <video
          loop
          muted
          preload="auto"
          poster="${poster}"
          playsinline
          webkit-playsinline
          class="${videoStyles.video} ${alignmentClasses}">
          <source type="video/mp4" src="${mp4}">
          ${trackElement}
          Your browser does not support the video tag. We suggest you upgrade your browser.
        </video>
        <div class="${videoStyles['subtitlescontainer']}"></div>
        ${bgInnerHTML}
      </div>
    `
  },
  onCurrentChanged(currentSection) {
    if (eventListener) {
      document.removeEventListener('scroll', eventListener)
      eventListener = null
    }

    const { type } = currentSection
    if (type === 'animate-video') {
      eventListener = () =>
        window.requestAnimationFrame(() => handleAnimateVideo(currentSection))
      document.addEventListener('scroll', eventListener)
    }
  }
}
let i = 0
const handleAnimateVideo = (section, e) => {
  const { y, top, height } = section.foregroundElement.getBoundingClientRect()
  const { innerHeight, innerWidth } = window

  const videoElement = document.querySelector('video')

  let pxInViewFromStart = height + (top || y) - innerHeight
  const howMuchBigger = height - innerHeight

  if (pxInViewFromStart >= howMuchBigger - 1) {
    pxInViewFromStart = howMuchBigger
  } else if (pxInViewFromStart <= 0) {
    pxInViewFromStart = 0
  }
  const percentInView = 1 - pxInViewFromStart / howMuchBigger

  const newCurrentTime = videoElement.duration * percentInView
  // videoElement.play()
  if (!isNaN(newCurrentTime)) {
    videoElement.currentTime = newCurrentTime
  }
  // console.log('asd', newCurrentTime)
}



// WEBPACK FOOTER //
// ./src/shared/components/animateVideo.js